var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2028_4837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.433594C24.8362 0.433594 32 7.59743 32 16.4336C32 25.2698 24.8358 32.4336 16 32.4336C7.16416 32.4336 0 25.2717 0 16.4336C0 7.59551 7.16288 0.433594 16 0.433594Z",
    fill: "#53AE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5365 14.3019V11.8473H24.1495V8.10742H8.86518V11.8473H14.4788V14.2999C9.91656 14.5094 6.48621 15.413 6.48621 16.4954C6.48621 17.5778 9.91821 18.4813 14.4788 18.6922V26.5544H18.5378V18.6915C23.0918 18.4813 26.5152 17.5784 26.5152 16.497C26.5152 15.4156 23.0918 14.5127 18.5378 14.3025M18.5378 18.0256V18.0236C18.4233 18.0309 17.8349 18.0662 16.5248 18.0662C15.4774 18.0662 14.7405 18.0365 14.4808 18.0229V18.0262C10.4502 17.8477 7.44156 17.1458 7.44156 16.3059C7.44156 15.4661 10.4505 14.7652 14.4808 14.5863V17.327C14.7448 17.3451 15.4998 17.3897 16.542 17.3897C17.7937 17.3897 18.423 17.3375 18.5385 17.327V14.5863C22.5612 14.7655 25.5628 15.4681 25.5628 16.305C25.5628 17.1418 22.5598 17.8447 18.5385 18.0239",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2028_4837"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.433594,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtWh);
export default __webpack_public_path__ + "static/media/usdtWH.c3b2b226ee0983e7aca576f450c38d20.svg";
export { ForwardRef as ReactComponent };